<template>
    <div @mouseover="date.hover = true"
         @mouseleave="date.hover = false"
         :class="['form-input',{'focus': focus},{'error': !dataValid}, {'disabled': disabled}]">
        <div :class="['input-label',{'active': inputValue}]" @click="focused()" v-html="label"></div>
        <input :type="type"
               ref="input"
               @focus="focus = true"
               @blur="blur()"
               @input="input()"
               :tabindex="disabled ? -1 : tabindex"
               :maxLength="maxLength"
               v-model="inputValue"/>

        <p v-show="!dataValid && !customError" :class="['error-text', {'error-text-not-absolute': forWhom === 'registration' && !shortRegistration}]">{{dataError}}</p>
        <p v-show="!dataValid && customError" :class="['error-text', {'error-text-not-absolute': forWhom === 'registration' && !shortRegistration}]">{{error}}</p>

        <!--Date Picker-->
        <div v-if="dateMode"
             v-show="focus"
             class="date-picker">
            <div class="date-list">
                <div class="date-slider">
                    <div class="angle-wrap">
                        <svg @click="dateSlide('back')" class="angle-left" width="8px" height="12px" fill="#000">
                            <use xlink:href="../../assets/images/sprite.svg#angle"></use>
                        </svg>
                    </div>
                    <span>{{date.monthYear|capitalize}}</span>
                    <div class="angle-wrap">
                        <svg @click="dateSlide('next')" class="angle-right" width="8px" height="12px" fill="#000">
                            <use xlink:href="../../assets/images/sprite.svg#angle"></use>
                        </svg>
                    </div>
                </div>
                <div class="date-weeks">
                    <span v-for="(item, key) in date.weeks"
                          :key="key">
                        {{item}}
                    </span>
                </div>
                <div ref="firstMonth"
                     class="date-month">
                    <div v-for="(item, key) in daysCount"
                         :key="key"
                         @click="selectDate(item)"
                         :class="['date-day',{'active': item.isActive},{'checked': item.isChecked}]">
                        {{item.day}}
                    </div>
                </div>
                <button @click="clearDate()"
                        class="date-clear-btn">
                    {{localizeList.resetFlightsUpper}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import {bus} from '../../main.js'

    export default {
        name: "form-input",
        data() {
            return {
                inputValue: "",
                focus: false,
                inputStatus: false,
                dataValid: true,
                dataError: "",
                date: {
                    current: moment().format("YYYY-MM-DD"),
                    activeDates: [],
                    weeks: [],
                    monthYear: "",
                    hover: false,
                    selectedItems: [],
                    list: [],
                },
                localDate: "",
                tabPressed: false
            }
        },
        props: {
            type: {
                type: String,
                default: "text"
            },
            value: {
                type: [String, Number],
                default: ""
            },
            label: {
                type: String,
                default: "label"
            },
            valid: {
                type: Boolean,
                default: true
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            parentFocus: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: ""
            },
            customError: {
                type: Boolean,
                default: false
            },
            dateMode: {
                type: Boolean,
                default: false
            },
            dateFrom: {
                type: String,
                default: ""
            },
            dateTo: {
                type: String,
                default: ""
            },
            tabindex: {
                type: Number
            },
            forWhom: {
                type: String
            },
            onlyNumbers: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            maxLength: {
                type: Number
            }
        },
        created() {
            bus.$on("localizeCode", code => {
                if (this.dateMode) {
                    code = code === "ua" ? "uk" : code
                    moment.locale(code);
                    this.calendarMounted()
                }
            })
        },
        mounted() {
            window.addEventListener("click", this.click);
            window.addEventListener("keydown", this.keydown);
            this.inputValue = this.value;
            this.dataValid = this.valid;
            this.dataError = this.localizeList[this.error];
            if (this.dateMode) {
                this.calendarMounted()
            }
        },
        computed: {
            shortRegistration() {
              return this.$store.getters['getSettings'].SimpleRegistration
            },
            daysCount() {
                let res = [];
                for (let i = 1; i <= moment(moment(this.date.current).format("YYYY-MM"), "YYYY-MM").daysInMonth(); i++) {
                    let dayConstuct = {
                        day: i,
                        isActive: false,
                        isChecked: false
                    }
                    const date = moment(this.date.current).format("YYYY.MM.") + (i > 9 ? i : `0${i}`);
                    let dateTime = new Date(date.replace(/\./g, "/")).getTime();
                    let dateFromTime = new Date(this.dateFrom.replace(/\./g, "/")).getTime();
                    let dateToTime = new Date(this.dateTo.replace(/\./g, "/")).getTime();

                    if (dateTime >= dateFromTime && dateTime <= dateToTime) {
                        dayConstuct.isActive = true;
                    } else {
                        dayConstuct.isActive = false;
                    }

                    if (dayConstuct.isActive) {
                        let isChecked = this.inputValue === date.split(".").reverse().join(".") ||
                            (this.inputValue.length !== 10 && this.localDate === date.replace(/\./g, "/"));

                        dayConstuct.isChecked = isChecked;
                    }

                    res.push(dayConstuct)
                }
                return res
            },
        },
        methods: {
            onlyNumbersMask(val) {
                let maskedVal = String(val).replace(/[^0-9]/g, '');
                if(!maskedVal) return
                this.inputValue = parseFloat(maskedVal);
                this.$emit("input", parseFloat(maskedVal));
            },
            calendarMounted() {
                this.date.monthYear = moment(this.date.current).format("MMMM YYYY");
                this.date.weeks = []
                for (let i = 1; i <= 7; i++) {
                    let day = "2020-06-" + `0${i}`;
                    let week = moment(day).format("ddd")
                    this.date.weeks.push(week)
                }
                this.setFirstDayInMonth();
            },
            keydown(e) {
                if (e.keyCode === 9) {
                    this.tabPressed = true;
                    setTimeout(() => this.tabPressed = false, 100)
                }
            },
            click() {
                if (!this.date.hover && this.focus) {
                    this.focus = false
                }
            },
            focused() {
                this.$refs.input.focus();
            },
            blur() {
                if (this.dateMode && this.inputValue.length && this.inputValue.length !== 10) {
                    this.inputValue = this.localDate.split("/").reverse().join(".")
                }

                if (this.dateMode) {
                    if (!this.date.hover || this.tabPressed) {
                        this.focus = false;
                        this.tabPressed = false
                    }
                } else {
                    this.focus = false;
                }
            },
            slideToSelectedDate(type = null) {
                let date = this.inputValue.split(".").reverse().join("/");
                let current = this.date.current.replace(/-/g, "/");
                const currentYear = current.split("/")[0];
                const currentMonth = current.split("/")[1];
                if (type === 'day') {
                    date = `${currentYear}/${currentMonth}/${date}`;
                }
                if (type === 'month') {
                    date = `${currentYear}/${date}`;
                }

                if (new Date(date) == "Invalid Date") return;
                const localDate = date;
                date = date.slice(0, 7);
                current = current.slice(0, 7);

                if (date > current) {
                    this.dateSlide("next");
                    this.slideToSelectedDate(type)
                } else if (date < current) {
                    this.dateSlide("back");
                    this.slideToSelectedDate(type)
                } else {
                    this.localDate = localDate
                }
            },
            input() {
                this.inputStatus = true;
                this.focus = true;
                if (!this.dateMode) return;

                if (this.inputValue.length === 2) {
                    this.date.current = moment().format("YYYY-MM-DD");
                    this.date.monthYear = moment(this.date.current).format("MMMM YYYY");
                    this.slideToSelectedDate('day');
                }
                if (this.inputValue.length === 5) {
                    this.date.current = moment().format("YYYY-MM-DD");
                    this.date.monthYear = moment(this.date.current).format("MMMM YYYY");
                    this.slideToSelectedDate('month');
                }
                if (this.inputValue.length === 10) {
                    this.slideToSelectedDate();
                }
            },
            selectDate(item) {
                if (!item.isActive) {
                    return
                }
                const date = (item.day > 9 ? item.day : `0${item.day}`) + moment(new Date(this.date.current)).format(".MM.YYYY");
                const selected = this.inputValue === date && !this.inputStatus;
                if (!selected) {
                    this.$emit("input", date)
                } else {
                    this.$emit("input", "")
                }
                setTimeout(() => this.focus = false)
            },
            dateSlide(to) {
                if (to === "next") {
                    this.date.current = moment(new Date(this.date.current)).add(1, 'M').format("YYYY-MM-DD");
                } else {
                    this.date.current = moment(new Date(this.date.current)).add(-1, 'M').format("YYYY-MM-DD");
                }

                this.date.monthYear = moment(this.date.current).format("MMMM YYYY");
            },
            clearDate() {
                this.$emit("input", "")
            },
            setFirstDayInMonth() {
                if (!this.$refs.firstMonth) return;

                this.$refs.firstMonth.childNodes[0].style.gridColumnStart = parseInt(moment(new Date(this.date.current)).startOf('month').format('E'));
            },
            setAutofocus(){
                if (this.autofocus)
                {
                    //костыль, нужно будет переделать
                     setTimeout(()=>{this.focused()},0);
                }
            }
        },
        watch: {
            value(val) {
                this.inputValue = val
            },
            localizeList(val) {
                this.dataError = val[this.error];
            },
            inputValue(val) {
                if (this.onlyNumbers) {
                  this.onlyNumbersMask(val);
                } else {
                   this.$emit("input", val)
                }
            },
            valid(val) {
                this.dataValid = val
            },
            error(val) {
                this.dataError = this.localizeList[val]
            },
            "date.current"() {
                this.setFirstDayInMonth();
            },
            focus(val) {
                if (!val){
                    this.inputStatus = false;
                    this.$emit("blur", true);
                }
                else {
                    this.$emit("focus", true);
                }
            },
            autofocus(){
                this.setAutofocus();
            },
            parentFocus(val){
                if (val){
                    this.focused();
                } else {
                    this.$refs.input.blur();
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener("click", this.click);
            window.removeEventListener("keydown", this.keydown);
        },
        filters: {
            capitalize(val) {
                return val.charAt(0).toUpperCase() + val.slice(1)
            }
        }
    }
</script>

<style scoped>
    .disabled {
        pointer-events: none;
    }
    .form-input {
        position: relative;
    }
    .form-input input {
        width: 100%;
        outline: none;
        border: none;
        border-bottom: 1px solid #aaa;
        padding: 5px 0;
        margin-top: 20px;
        font-weight: 500;
        font-size: 15px;
        color: #1D1D1D;
        box-shadow: inset 0 0 0 50px var(--white-color);
    }
    .error.form-input input {
        border-bottom: 1px solid red;
    }
    .form-input:before{
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 2px;
        background-color: var(--primary-color);
        transition: all .4s;
    }
    .focus.form-input:before {
        left: 0;
        width: 100%;
    }
    .error.form-input:before {
        left: 50%;
        width: 0;
    }
    .form-input .input-label {
        position: absolute;
        top: calc(50% + 4px);
        transform: translateY(-50%);
        font-size: 15px;
        color: var(--lighten-5-color);
        z-index: 1;
        transition: all .2s;
    }
    .form-input .input-label.active {
        top: 6px;
        transform: translateY(0);
        font-size: 13px;
        font-weight: 300;
    }
    .form-input.focus .input-label {
        top: 6px;
        transform: translateY(0);
        font-size: 13px;
        font-weight: 300;
        color: var(--primary-color);
    }
    .form-input .error-text {
        position: absolute;
        left: 0;
        top: calc(100% + 3px);
        color: red;
        font-size: 12px;
    }

    .form-input .error-text-not-absolute {
        position: static;
    }

    /*Date Picker*/
    .form-input .date-list .date-item.info {
        cursor: default;
        white-space: nowrap;
        font-size: 15px;
        color: #313131;
    }

    .form-input .date-picker .date-list.info {
        padding: 12px;
    }

    .form-input .date-picker .date-list {
        position: absolute;
        top: calc(100% + 5px);
        left: 50%;
        transform: translateX(-50%);
        background-color: var(--white-color);
        border-radius: 6px;
        box-shadow: 0 0 15px 0 rgba(100, 100, 100, .4);
        padding: 16px;
        cursor: default;
        z-index: 10;
    }

    .form-input .date-picker .date-list .date-slider {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .form-input .date-picker .date-list .date-slider span {
        color: #313131;
    }

    .form-input .date-picker .date-list .date-slider .angle-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: #eee;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        transition: all .2s;
    }

    .form-input .date-picker .date-list .date-slider .angle-wrap:hover {
        background-color: #ddd;
    }

    .form-input .date-picker .date-list .date-slider .angle-right {
        transform: rotate(180deg);
    }

    .date-picker .date-weeks {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin: 10px 0;
    }

    .date-picker .date-weeks span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--lighten-7-color);
    }

    .form-input .date-picker .date-weeks span:nth-last-child(1),
    .form-input .date-picker .date-weeks span:nth-last-child(2) {
        color: var(--green-5-color);
    }

    .form-input .date-picker .date-month {
        width: 280px;
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        grid-row-gap: 3px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #aaa;
    }

    .form-input .date-picker .date-month .date-day {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        color: var(--lighten-5-color);
        transition: all .2s;
    }

    .form-input .date-picker .date-month .date-day.active {
        background-color: var(--green-3-color);
        opacity: .5;
        transition: all .2s;
        cursor: pointer;
    }

    .form-input .date-picker .date-month .date-day.active:hover,
    .form-input .date-picker .date-month .date-day.checked {
        opacity: 1;
        color: var(--white-color);
    }

    .form-input .date-picker .date-clear-btn {
        border: none;
        border-radius: 6px;
        background-color: var(--lighten-6-color);
        color: #727272;
        display: block;
        width: 100%;
        text-align: center;
        padding: 4px 0;
        margin-top: 10px;
        outline: none;
        transition: all .2s;
    }

    .form-input .date-picker .date-clear-btn:hover {
        filter: brightness(90%);
    }
</style>
